import { useState } from "react";
import { Paperclip, X } from "lucide-react";
import { filesApi, type AttachKind } from "../lib/api";
import { errText, useLoad } from "../ui/useLoad";
import { ErrorNote } from "../ui/bits";
import { fileToB64, mimeOf, openB64, sizeText } from "./files";

// files kept with an entry, order, account or item: the bill behind an entry, a contract, a GST certificate (sql/231)
export function Attachments({ companyId, kind, id, canEdit = true }: { companyId: string; kind: AttachKind; id: string; canEdit?: boolean }) {
  const { data, setData } = useLoad(() => filesApi.list(companyId, kind, id), [companyId, kind, id]);
  const [busy, setBusy] = useState(false); const [err, setErr] = useState<string | null>(null);
  const add = async (files: FileList | null) => {
    if (!files?.length) return;
    setBusy(true); setErr(null);
    try {
      for (const f of Array.from(files)) {
        if (f.size > 10 * 1048576) throw new Error(`${f.name} is over 10 MB`);
        setData(await filesApi.add(companyId, kind, id, { filename: f.name, mime: mimeOf(f), data: await fileToB64(f) }));
      }
    } catch (e) { setErr(errText(e)); } finally { setBusy(false); }
  };
  return (
    <section className="attachments">
      <div className="row"><Paperclip size={14} aria-hidden="true" /> <b className="small">Files</b>
        {canEdit && <label className="link small">{busy ? "Adding…" : "Attach"}<input type="file" hidden multiple onChange={(e) => { void add(e.target.files); e.target.value = ""; }} /></label>}</div>
      {(data ?? []).length > 0 && <ul className="plain-list small">{data!.map((a) => (
        <li key={a.id}><button className="link" onClick={() => void filesApi.file(companyId, a.id).then(openB64).catch((e) => setErr(errText(e)))}>{a.filename}</button>
          <span className="muted"> · {sizeText(a.size)}{a.added_by ? ` · ${a.added_by}` : ""}</span>
          {canEdit && <button className="link" aria-label={`Remove ${a.filename}`} onClick={() => void filesApi.remove(companyId, a.id).then(setData).catch((e) => setErr(errText(e)))}><X size={12} /></button>}</li>))}</ul>}
      <ErrorNote text={err} />
    </section>
  );
}
